import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { DebtScheduleItem } from 'ng2-app/models/dscr/DebtScheduleItem.struct';
import { DscrResult } from 'ng2-app/models/dscr/DscrResult.struct';
import { ProfitLossStatement } from 'ng2-app/models/dscr/ProfitLossStatementItem.struct';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DscrService {
  constructor(
    private http: ApiHttpClient,
  ) {}

  getDscrResults(borrowerId: number): Observable<any> {
    return this.http.get(`${environment.API_URL}/borrower/${borrowerId}/dscr-results`);
  }

  getProfitLossStatements(borrowerId: number): Observable<ProfitLossStatement[]> {
    return this.http.get<ProfitLossStatement[]>(`${environment.API_URL}/borrower/${borrowerId}/profit-loss-statement-items`);
  }

  createProfitLossStatement(borrowerId: number, profitLossStatement: ProfitLossStatement): Observable<ProfitLossStatement[]> {
    return this.http.post<ProfitLossStatement[]>(
      `${environment.API_URL}/borrower/${borrowerId}/profit-loss-statement-items`,
      profitLossStatement
    );
  }

  updateProfitLossStatement(borrowerId: number, profitLossStatement: ProfitLossStatement): Observable<ProfitLossStatement> {
    return this.http.post<ProfitLossStatement>(
      `${environment.API_URL}/borrower/${borrowerId}/profit-loss-statement-items`,
      profitLossStatement
    );
  }

  processDscrResults(borrowerId: number): Observable<DscrResult[]> {
    return this.http.post<DscrResult[]>(`${environment.API_URL}/borrower/${borrowerId}/process-dscr-results`, {});
  }
}
